// 车牌识别
export default {
    licensePlate: '车牌号码',
    pictureName: '图片名称',
    identificationPeriod: '识别时段',
    identified: '已识别',
    unrecognized: '未识别',
    IR: '识别结果',
    reliability: '可信度',
    LPR: '识别车牌',
    PEAN: '请输入名称',
    TLIB: '长度在 1 到 20 个字符',
}